// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"abnormalFileHistory_fileStatusContainer__2MkWf","loadMoreBtnContainer":"abnormalFileHistory_loadMoreBtnContainer__wCC40"};